import cCvcHint from '#themes/default/default/components/cvcHint/cvcHint.js';
import cSkeleton from '#themes/default/default/components/skeleton/skeleton.js';
import cSvg from '#themes/default/default/components/svg/svg.js';

import getCardTitle from '#frontend/util/getCardTitle.js';

import template from './cardInput.html' with { type: 'html' };

export default {
	name: 'CCardInput',
	components: {
		cCvcHint,
		cSkeleton,
		cSvg
	},
	props: {
		cardExpirationHasError: {
			type: Boolean,
			default: false
		},
		cardNumberHasError: {
			type: Boolean,
			default: false
		},
		cardSecurityCodeHasError: {
			type: Boolean,
			default: false
		},
		form: {
			type: Object,
			default: () => {}
		},
		isEmpty: {
			type: Boolean,
			default: true
		},
		isCvcFocused: {
			type: Boolean,
			default: false
		},
		isCvcTouched: {
			type: Boolean,
			default: false
		},
		isOnlyCvc: {
			type: Boolean,
			default: false
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		showLogos: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'medium'
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			note: '',
			hasFocus: false
		};
	},
	computed: {
		isTouched() {
			return Boolean(this.form.creditCard?.touched);
		},
		isSubmitted() {
			return Boolean(this.form.creditCard?.submitted);
		},
		isCompleted() {
			return Boolean(this.form.creditCard?.completed);
		},
		isCreditCard() {
			return this.selectedPayment?.type === 'creditCard';
		},
		isBancontact() {
			return this.selectedPayment?.type === 'bancontact';
		},
		isSubmittedUntouched() {
			return this.isSubmitted && !this.isTouched;
		},
		isAutofilled() {
			return this.isSubmitted && !this.isCvcTouched && !this.isOnlyCvc && this.isCreditCard;
		},
		creditCardErrors() {
			return this.cardNumberHasError || this.cardExpirationHasError || this.cardSecurityCodeHasError || this.isSubmittedUntouched || this.isAutofilled;
		},
		cardTitle() {
			return getCardTitle(this.selectedPayment.cardBrand, this.t('paymentMethod_creditCard'));
		},
		getCardIcon() {
			const cardBrand = this.selectedPayment.cardBrand;
			const card = ['visa', 'amex', 'mastercard', 'dinersclub', 'discover', 'jcb', 'unionpay', 'bancontact_card', 'elo', 'hipercard'].includes(cardBrand) ? cardBrand : 'card';
			return `#payment-${card}`;
		},
		inputsLoaded() {
			const creditCardCvcInputLoaded = Boolean(this.selectedPayment.cardcvv);
			const creditCardInputsLoaded = Boolean(creditCardCvcInputLoaded && this.selectedPayment.cardexpiration && this.selectedPayment.cardnumber);
			const bancontactInputsLoaded = Boolean(this.selectedPayment.cardexpiration && this.selectedPayment.cardnumber);
			if (this.isBancontact) {
				return bancontactInputsLoaded;
			} else {
				return this.isOnlyCvc ? creditCardCvcInputLoaded : creditCardInputsLoaded;
			}
		}
	},
	methods: {
		onBlur() {
			this.hasFocus = false;
			this.note = '';
		},
		onFocus(target = {}, note) {
			this.hasFocus = true;
			// Display note when CVC has been focused
			if (target && target.elementType === 'cardcvv' && note) {
				this.note = note;
			}
		}
	},
	template
};
